import React, { useState, useEffect } from "react";
import { Github, Linkedin } from "lucide-react";
import "./devoloperCard.css";
const CodeEditorDeveloperCard = ({ developer }) => {
    const [activeTab, setActiveTab] = useState("info");
    const [isTyping, setIsTyping] = useState(true);
    const [typedContent, setTypedContent] = useState("");

    useEffect(() => {
        setIsTyping(true);
        setTypedContent("");
        let content = "";
        switch (activeTab) {
            case "info":
                content = `
    name: "${developer.name}",
    position: "${developer.position}",
    description: "${developer.description}",
    skills: [
    ${developer.skills.map((skill) => `"${skill}"`).join(",\n  ")}
    ],
            `;
                break;
            case "code":
                content = developer.favoriteCode;
                break;
            default:
                break;
        }

        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < content.length) {
                setTypedContent((prev) => prev + content.charAt(i));
                i++;
            } else {
                clearInterval(typingInterval);
                setIsTyping(false);
            }
        }, 20);

        return () => clearInterval(typingInterval);
    }, [activeTab, developer]);

    return (
        <div className="bg-gradient-to-br from-indigo-900 to-pink-900 text-indigo-100 p-6 rounded-lg font-mono text-sm md:text-base overflow-hidden">
            <div className="flex items-center justify-between mb-4">
                <div className="flex space-x-2">
                    <button
                        onClick={() => setActiveTab("info")}
                        className={`px-3 py-1 rounded ${activeTab === "info" ? "bg-indigo-600 text-white" : "bg-indigo-800 text-indigo-200"
                            }`}
                        aria-label="Show developer info"
                    >
                        info.json
                    </button>
                    <button
                        onClick={() => setActiveTab("code")}
                        className={`px-3 py-1 rounded ${activeTab === "code" ? "bg-indigo-600 text-white" : "bg-indigo-800 text-indigo-200"
                            }`}
                        aria-label="Show developer's favorite code"
                    >
                        favorite-code.js
                    </button>
                </div>
                <div className="flex space-x-2">
                    <a
                        href={developer.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-indigo-200 hover:text-pink-300 transition-colors duration-300"
                        aria-label="GitHub Profile"
                    >
                        <Github size={20} />
                    </a>
                    <a
                        href={developer.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-indigo-200 hover:text-pink-300 transition-colors duration-300"
                        aria-label="LinkedIn Profile"
                    >
                        <Linkedin size={20} />
                    </a>
                </div>
            </div>
            <div className="flex mb-4">
                <div className="w-1/4">
                    <img style={{ width: '175px' }}
                        src={developer.avatar}
                        alt={developer.name}
                        className="rounded-full border-2 border-indigo-200"
                    />
                </div>
                <div className="w-3/4 pl-4">
                    <h3 className="text-xl font-bold mb-2">{developer.name}</h3>
                    <p className="text-pink-300">{developer.position}</p>
                </div>
            </div>
            <div className="bg-indigo-950 p-4 rounded">
                <pre className="whitespace-pre-wrap">
                    <code className="text-pink-100">{typedContent}</code>
                </pre>
                {isTyping && <span className="animate-pulse text-pink-300">▋</span>}
            </div>
        </div>
    );
};

export default CodeEditorDeveloperCard;
